// Active illustrations in display order; persisted step IDs remain stable.
export const ONBOARDING_ARTWORK = [
  { step: 0, source: require('@/assets/images/onboarding/pixel-welcome.webp'), label: "Gab AI Pixel · WELCOME" },
  { step: 1, source: require('@/assets/images/onboarding/pixel-profile.webp'), label: "Gab AI Pixel · ABOUT YOU" },
  { step: 15, source: require('@/assets/images/onboarding/pixel-modes.webp'), label: "Gab AI Pixel · TWO WAYS TO WORK" },
  { step: 16, source: require('@/assets/images/onboarding/pixel-ready.webp'), label: "Gab AI Pixel · READY WHEN YOU ARE" },
];
